<template>
  <v-expansion-panels
    class="AccordionComponent"
    v-model="state"
  >
    <v-expansion-panel :elevation="0">
      <v-expansion-panel-title>
        {{ title }}
      </v-expansion-panel-title>

      <v-expansion-panel-text :eager="true">
        <slot />
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script setup lang="ts">
import { ref } from 'vue'
const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  open: {
    type: Boolean,
    default: false
  }
})

const panelOpenIndex = props.open ? 0 : -1
const state = ref(panelOpenIndex)
</script>

<style lang="scss" scoped>
.AccordionComponent {
  max-width: $size-650;
  margin: 0 auto;

  .v-expansion-panel-title {
    color: $color-primary;
    font-size: $font-size-20;
    font-weight: $font-weight-700;
    background-color: transparent;
    padding: $spacing-xl 0.5rem;
    border-radius: $b-radius-0;
    border-bottom: solid 1px $color-neutral-light;

    &--active {
      border: none;
    }
  }

  :deep(.v-expansion-panel-title--active > .v-expansion-panel-title__overlay) {
    background-color: transparent;
  }

  :deep(.v-expansion-panel-text__wrapper) {
    padding: 0;
  }
}
</style>
